import { mergeSx } from '@/shared/utils/merge-sx.util';
import palette from '@/theme/themePalette';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { ComponentPropsWithoutRef } from 'react';

const valueStyles = {
  text: { fontSize: '14px', lineHeight: '24px' },
  error: {
    color: palette.error.main,
  },
};

type RiApplicationDetailsAddressValueProps = ComponentPropsWithoutRef<typeof Typography> & {
  isLoading: boolean;
  isReasonError: boolean;
  skeletonProps?: ComponentPropsWithoutRef<typeof Skeleton>;
};
export function RiApplicationDetailsAddressValue({
  isLoading,
  isReasonError,
  skeletonProps,
  children,
  sx,
  ...props
}: RiApplicationDetailsAddressValueProps) {
  if (isLoading) {
    return <Skeleton {...skeletonProps} />;
  }

  const mergedSx = mergeSx(valueStyles.text, sx, isReasonError && valueStyles.error);

  return (
    <Typography sx={mergedSx} {...props}>
      {children}
    </Typography>
  );
}
